import moment from 'moment';

/**
 * Format an event date/time based on the Kennedy Center's branding guidelines
 */
export function formatDateTime(moment: moment.Moment, formatString: string): string {
    return moment.format(formatString).replace('am', 'a.m.').replace('pm', 'p.m.').replace('May.', 'May');
}